export const Roles = {
    AGENCY: "agency",
    ADMIN: "admin",
    SUPERADMIN: "superadmin",
    POS: "pos",
} as const;

export const Types = {
    AGENCY: "agency_user",
    ADMIN: "admin",
} as const;
